import { useBlocker } from "react-router-dom";

export function useUnsavedChangesBlocker(shouldBlock: boolean) {
  const blocker = useBlocker(
    ({ currentLocation, nextLocation }) =>
      shouldBlock && currentLocation.pathname !== nextLocation.pathname
  );

  return {
    isBlocked: blocker.state === "blocked",
    proceed: () => blocker.proceed?.(),
    cancel: () => blocker.reset?.(),
  };
}
